var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82A53",
    d: "M4.1984 1.4c-.7722 0-1.4.6278-1.4 1.4v2.1h1.4V2.8h4.9591l.641.641V4.9h1.3999V3.441c0-.372-.1465-.7285-.409-.991l-.641-.641a1.4 1.4 0 0 0-.9909-.409zm5.6 7.7v2.1h-5.6V9.1zm1.4.7h.7c.3872 0 .7-.3128.7-.7V7c0-.7722-.6278-1.4-1.4-1.4h-8.4c-.7721 0-1.4.6278-1.4 1.4v2.1c0 .3872.3128.7.7.7h.7v1.4c0 .7722.6279 1.4 1.4 1.4h5.6c.7722 0 1.4-.6278 1.4-1.4zm-.35-2.975a.5252.5252 0 0 1 .3713.8963.5251.5251 0 0 1-.8963-.3713.5253.5253 0 0 1 .525-.525"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/printer.78959942109676d69c0ba4bec9e471fd.svg";